module.exports = __webpack_public_path__ + "img/page6.bcdf986d.png";